import OrderTypeEnum from '@/app-core/api/enums/OrderTypeEnum'

export default {
  name    : 'StoreCommon',
  mixins  : [],
  computed: {
    cartOrderTypeIsDelivery() {
      return this.AppCart?.OrderType === OrderTypeEnum.DELIVERY
    },
    cartOrderTypeIsCollection() {
      return this.AppCart?.OrderType === OrderTypeEnum.COLLECTION
    }
  },
  methods: {
    storeIsClosedById(id) {
      const store = this.getStoreById(id)
      return this.storeIsClosed(store)
    },
    storeIsClosed(store) {
      return !!store?.Status?.IsClosed
    },
    storeIsOpenedById(id) {
      const store = this.getStoreById(id)
      return !this.storeIsClosed(store)
    },
    storeIsOpened(store) {
      return !this.storeIsClosed(store)
    },

    storeCanSellItemsById(id) {
      const store = this.getStoreById(id)
      return this.storeCanSellItems(store)
    },

    storeCanSellItems(store) {
      return this.storeIsOpened(store) && ((this.storeHasDelivery(store) && this.cartOrderTypeIsDelivery) || (this.storeHasCollection(store) && this.cartOrderTypeIsCollection))
    },

    storeHasDelivery(store) {
      const supportsDelivery = !!this.AppConfig?.Marketplace?.SupportsDelivery
      const storeHasDelivery = !!store?.Status?.HasDelivery
      return supportsDelivery && storeHasDelivery
    },

    storeHasMarketplaceDelivery(store) {
      return this.storeHasDelivery(store) && !!store?.MarketplaceDelivery
    },

    storeHasCollection(store) {
      const supportsCollection = !!this.AppConfig?.Marketplace?.SupportsCollection
      const storeHasCollection = !!store?.Status?.HasCollection
      return supportsCollection && storeHasCollection
    },

    storeIsDisabledById(id) {
      const store = this.getStoreById(id)
      return this.storeIsDisabled(store)
    },
    storeIsDisabled(store) {
      return this.AppConfig?.StoreClosed?.DisableStore && !this.storeCanSellItems(store)
    },
    storeIsHiddenById(id) {
      const store = this.getStoreById(id)
      return this.storeIsHidden(store)
    },
    storeIsHidden(store) {
      return this.AppConfig?.StoreClosed?.HideStore && !this.storeCanSellItems(store)
    },

    storeDefaultTimeById(id) {
      const store = this.getStoreById(id)
      return this.storeDefaultTime(store)
    },
    storeDefaultTime(store, suffix) {
      suffix = suffix?.toUpperCase() || this.$vuetify.breakpoint.name.toUpperCase()
      const defaultTime = this.AppCart.OrderType === OrderTypeEnum.COLLECTION ? store?.Status?.CollectionTime || 0 : store?.Status?.DeliveryTime || 0
      return `${defaultTime}${suffix === 'XS' ? '' : ' '}${this.$t('Store.OrderTime.Suffix' + suffix?.toUpperCase() || '')}`
    },

    storeLogoById(id) {
      const store = this.getStoreById(id)
      return store.Logo || ''
    },

    storeNameById(id) {
      const store = this.getStoreById(id)
      return store.Name || ''
    },

    storeCatalogTagsById(id) {
      const store = this.getStoreById(id)
      return store.Tags || []
    },

    getStoreById(id) {
      return this.AppStores?.find(store => parseInt(store.Id) === parseInt(id))
    },

    getCartStoreById(id) {
      return this.AppCart?.Stores?.find(store => parseInt(store.StoreId) === parseInt(id))
    },

    gotoStoreCatalog(storeId) {
      if (!storeId) return

      const store = this.getStoreById(storeId)
      if (!store || this.storeIsDisabled(store)) return

      this.$router.push({name: 'Store', params: {slug: store.Slug, id: store.Id}})
    }

  }
}
